var map = {
	"./ink": 858,
	"./ink.ts": 858,
	"./mpha": 859,
	"./mpha.ts": 859,
	"./pof": 860,
	"./pof.ts": 860,
	"./prz": 862,
	"./prz.ts": 862,
	"./rep": 863,
	"./rep.ts": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1398;